import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { getItemOptionsOfItem, type ItemOption } from '@/js/lib/api/item';
import ISelect from '@/js/components/molecules/ISelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemOptions',
  props: {
    itemId: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', itemOptionVariantSlugs: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  itemId: number;
};



const cartButtonEl = document.querySelector('.cart-button');
const itemOptions = ref<ItemOption[]>([]);
const formatSelectItems = (itemOption: ItemOption) =>
  [
    itemOption.required ? undefined : { value: '', label: '選択しない' },
    ...itemOption.itemOptionVariants.map((variant) => {
      return {
        value: variant.itemOptionVariantSlug,
        label: `${variant.name}${variant.price > 0 ? `（¥${variant.price.toLocaleString()}）` : ''}`,
      };
    }),
  ].filter(Boolean);
const itemOptionVariantSlugs = ref<string[]>(itemOptions.value.map(() => ''));
const onSelectChange = () => {
  emit('input', itemOptionVariantSlugs.value.filter(Boolean));
};
onMounted(async () => {
  const data = await getItemOptionsOfItem(props.itemId);
  itemOptions.value = data.itemOptions;
  cartButtonEl.removeAttribute('style');
});

return { __sfc: true,props, emit, cartButtonEl, itemOptions, formatSelectItems, itemOptionVariantSlugs, onSelectChange, ISelect }
}

})